export default __webpack_public_path__ + "assets/b8560581b5cf703eaa0b65130dcf99c7.svg";